import moment from 'moment-jalaali';

const FA_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

/** نام ماه‌های شمسی؛ بدون loadPersian تا فرمت‌های عددی بقیهٔ سایت تغییر نکند */
const JALALI_MONTHS = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
];

/** تبدیل ارقام لاتین به فارسی */
export const toFaDigits = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/\d/g, (d) => FA_DIGITS[Number(d)]);
};

/** «۲۴ اردیبهشت ۱۴۰۳» */
export const formatBlogDate = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  const m = moment(date);
  if (!m.isValid()) return '';
  return `${toFaDigits(m.jDate())} ${JALALI_MONTHS[m.jMonth()]} ${toFaDigits(m.jYear())}`;
};

/** «۸ دقیقه مطالعه» */
export const formatReadingTime = (minutes: number | null | undefined, suffix = 'مطالعه'): string => {
  const mins = Math.max(1, Math.round(minutes || 1));
  return `${toFaDigits(mins)} دقیقه${suffix ? ` ${suffix}` : ''}`;
};

/** مدت ویدیو به شکل «۴:۳۰» یا «۱:۰۲:۱۵» */
export const formatVideoDuration = (seconds: number | null | undefined, padMinutes = false): string => {
  const total = Math.max(0, Math.floor(seconds || 0));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  // طرح موبایل دقیقه را دو رقمی می‌نویسد (۰۴:۳۰)، دسکتاپ نه (۴:۳۰)
  const mm = h || padMinutes ? String(m).padStart(2, '0') : String(m);
  const ss = String(s).padStart(2, '0');
  return toFaDigits(h ? `${h}:${mm}:${ss}` : `${mm}:${ss}`);
};

/** «۴۸ مقاله» */
export const formatArticleCount = (count: number): string => `${toFaDigits(count)} مقاله`;

const ZWNJ = new RegExp(String.fromCharCode(0x200c), 'g');

/** دو حرف اول نام برای آواتار متنی (طبق طرح: «تح» برای «تحریریه من حقیقی») */
export const nameInitials = (name: string | null | undefined): string => {
  const first = (name || '').trim().split(/\s+/)[0] || '';
  // نیم‌فاصله (ZWNJ) حرف حساب نمی‌شود
  return first ? Array.from(first.replace(ZWNJ, '')).slice(0, 2).join('') : 'م';
};

/** یک حرف برای آواتار کوچک موبایل؛ طبق طرح حرف اول آخرین کلمه («ح» برای «تحریریه من حقیقی») */
export const nameLastInitial = (name: string | null | undefined): string => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  return words.length ? Array.from(words[words.length - 1])[0] : 'م';
};

/** هشتگ برچسب؛ فاصله‌ها «_» می‌شوند و در دسکتاپ (طبق طرح) نیم‌فاصله هم */
export const tagHashtag = (tag: string, replaceZwnj = false): string => {
  const text = tag.trim().replace(/\s+/g, '_');
  return `#${replaceZwnj ? text.replace(ZWNJ, '_') : text}`;
};

/** حذف تگ‌های HTML برای پیش‌نمایش/توضیحات متا */
export const stripHtml = (html: string | null | undefined, maxLength?: number): string => {
  const text = (html || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (maxLength && text.length > maxLength) return `${text.slice(0, maxLength).trim()}…`;
  return text;
};
